(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-article"]) return;
  try {
    
  function isValidEmail(email) {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailPattern.test(email);
  }

  document.addEventListener('DOMContentLoaded', function () {
    const containers = document.querySelectorAll('.subscribe-form-container');

    containers.forEach(function (formWrapper, index) {
      const form = formWrapper.querySelector('.subscribe-form');
      const emailInput = formWrapper.querySelector('.email-id');
      const thankYouMessage = formWrapper.querySelector('.thank-you-message');
      const errorBox = formWrapper.querySelector('.error-subscribe');

      form.addEventListener('submit', function (e) {
        e.preventDefault();

        const email = emailInput.value.trim();
        errorBox.style.display = 'none';

        if (!isValidEmail(email)) {
          errorBox.textContent = 'Please enter a valid email address.';
          errorBox.style.display = 'block';
          return;
        }

        const formData = new FormData(form);

        fetch('/contact', {
          method: 'POST',
          body: formData,
          headers: {
            Accept: 'text/html', // Shopify returns HTML, not JSON
            'X-Requested-With': 'XMLHttpRequest',
          },
        })
          .then(function (response) {
            if (response.status === 429) {
              errorBox.textContent = 'Too many requests. Please try again later.';
              errorBox.style.display = 'block';
              return;
            }

            if (!response.ok) {
              errorBox.textContent = 'Something went wrong. Please try again.';
              errorBox.style.display = 'block';
              return;
            }

            // Success (Shopify will send a 200 with HTML)
            form.style.display = 'none';
            if (thankYouMessage) thankYouMessage.style.display = 'block';
          })
          .catch(function (error) {
            console.error('Error submitting the form:', error);
            errorBox.textContent = 'Network error. Please try again later.';
            errorBox.style.display = 'block';
          });
      });

      // Input limit
      emailInput.addEventListener('beforeinput', function (event) {
        const text = event.target.value;
        const maxLength = 50;
        const selection = window.getSelection().toString();
        const inputType = event.inputType;

        if (text.length >= maxLength && inputType !== 'deleteContentBackward' && selection === '') {
          event.preventDefault();
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
